import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

/**
 * トップページ　PROJECTスライダー
*/
const topProjectSlider = () => {
    const prev = document.querySelector('.js_topProjectSliderPrev');
    const next = document.querySelector('.js_topProjectSliderNext');

    const swiper = new Swiper('.js_topProjectSlider', {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        breakpoints: {
            768: {
                spaceBetween: 40,
            }
        }
    });

    //-------------- 一旦非表示 --------------
    // slidesPerView: 'auto'の場合の最後のスライドの計算が煩雑なため

    // // ページナビの無効化
    // const disablePageNav = () => {
    //     const currentSlide = swiper.activeIndex;
    
    //     // 最初のスライド
    //     if (currentSlide === 0) {
    //         prev.classList.add('is_disabled');
    
    //     // 最後のスライド
    //     } else if (currentSlide === swiper.slides.length - 1) {
    //         next.classList.add('is_disabled');
    
    //     // それ以外
    //     } else {
    //         prev.classList.remove('is_disabled');
    //         next.classList.remove('is_disabled');
    //     }
    // }
    // disablePageNav(); //初期実行
    // swiper.on('slideChange', disablePageNav); //スライド変更時に実行
}

export default topProjectSlider;